import { useEffect } from "react";

export default function useDynamicSubtabs({
  parentKey,
  sourceData = [],
  registerDynamicTabs,
  keyPrefix = "dynamic",
}) {
  useEffect(() => {
    if (!registerDynamicTabs || !parentKey) return;

    if (!Array.isArray(sourceData) || sourceData.length === 0) {
      registerDynamicTabs(parentKey, []);
      return;
    }

    // const tabs = sourceData.map((item, index) => ({
    //   key: `${keyPrefix}_${index}`,
    //   label: item?.response?.subdimension_name || `Dynamic ${index + 1}`,
    //   isDynamic: true,
    // }));

    const tabs = sourceData.map((item, index) => ({
      key: `${keyPrefix}_${index}`,
      label: (
        <>
          {item?.response?.subdimension_name || `Dynamic ${index + 1}`}{" "}
          <img
            src="/img/ai_assitant1.png"
            alt="icon"
            className="filter_icon"
            style={{ width: "15px", marginRight: "7px" }}
          />
        </>
      ),
      isDynamic: true,
    }));

    registerDynamicTabs(parentKey, tabs);
  }, [parentKey, sourceData, registerDynamicTabs, keyPrefix]);
}
